import Link from 'next/link';
import { PropsWithChildren } from 'react';
import { routes } from '~/utils/routes';
import {
  Box,
  Center,
  CenterProps,
  HStack,
  Paragraph,
  styled,
} from '@styled-system/jsx';

const StyledLink = styled(Link);

type Props = {
  selectedTab?: 'ranking' | 'contests' | 'publication';
  hasNewContest?: boolean;
} & CenterProps;

export const HeaderBottomTab = ({
  hasNewContest,
  selectedTab,
  ...centerProps
}: Props) => {
  return (
    <Center w="100%" h="48px" {...centerProps}>
      <HStack gap="12" h="100%">
        <TabItem
          selected={selectedTab === 'ranking'}
          path={routes.genre.ranking.url('horror')}
        >
          ランキング
        </TabItem>
        <TabItem
          selected={selectedTab === 'contests'}
          path={routes.contests.list.url()}
          newBadge={hasNewContest}
        >
          コンテスト
        </TabItem>
        <TabItem
          selected={selectedTab === 'publication'}
          path={routes.publication.url()}
        >
          出版・メディアミックス作品
        </TabItem>
      </HStack>
    </Center>
  );
};

type TabItemProps = PropsWithChildren<{
  selected: boolean;
  path: string;
  newBadge?: boolean;
}>;

const TabItem = ({ selected, path, newBadge, children }: TabItemProps) => {
  return (
    <StyledLink
      href={path}
      borderBottomWidth={selected ? 2 : 0}
      borderColor="content_primary"
      h="100%"
      position="relative"
    >
      <Center h="100%">
        <Paragraph
          color="content_primary"
          fontSize="size_14"
          fontWeight="bold"
          w="100%"
          lineHeight={1.25}
          pt="8px"
        >
          {children}
        </Paragraph>
      </Center>
      {newBadge && (
        <Box
          position="absolute"
          top="10px"
          right="-8px"
          bg="red"
          borderRadius="full"
          w="8px"
          h="8px"
        />
      )}
    </StyledLink>
  );
};
